import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const GeneralSettingsEdit = lazyLoader(
  () =>
    import(
      "Containers/Settings/GeneralSettings/GeneralSettingEdit/GeneralSettingsEdit"
    )
);

export const GeneralSettingsEditLayout = () => {
  return (
    <Layout>
      <GeneralSettingsEdit />
    </Layout>
  );
};
